import CloseJobPostPage from "@/pages/_layouts/jobs/close/CloseJobPostPage";

export default CloseJobPostPage;
